import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LedgerEntrySchema = withDefaults({
  type: 'ledger-entry',
  fields: [
    {
      kind: 'attribute',
      name: 'creditAmount',
    },
    {
      kind: 'attribute',
      name: 'debitAmount',
    },
    {
      kind: 'attribute',
      name: 'entryDate',
    },
    {
      kind: 'attribute',
      name: 'itemType',
    },
    {
      kind: 'attribute',
      name: 'itemId',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'product',
    },
    {
      kind: 'belongsTo',
      name: 'ledgerAccount',
      type: 'ledger-account',
      options: {
        async: false,
        inverse: 'ledgerEntries',
      },
    },
    {
      kind: 'belongsTo',
      name: 'ledgerEvent',
      type: 'ledger-event',
      options: {
        async: false,
        inverse: 'ledgerEntries',
      },
    },
  ],
});

export default LedgerEntrySchema;
